<template>
  <div ref="scrollContainer" id="page-panel">
    <resize-observer @notify="__resizeHanlder" />
    <div class="customer-top-nav no-print">
      <div class="title">
        <span>Gestion des courriels personnalisés</span>
      </div>
      <div class="controls">
         <el-button type="primary" @click="createEcc"><i class="mdi mdi-plus-circle"><span style="padding-left:5px;">Nouveau</span></i> </el-button>
      </div>
    </div>
    <el-table
      :data="emailCustomContents"
      stripe
      border
      resizable
      :height="getHeightStyle"
      v-loading=loading
      empty-text="Il n'existe aucun gabarit de courriel personnalisé"
      style="width: 100%">
      <el-table-column
        prop="type.code"
        sortable
        label="Type">
        <template slot-scope="scope">
          <span>{{$t('email_custom_content.types.'+scope.row.type.code)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="description"
        sortable
        label="Description">
      </el-table-column>
      <el-table-column
        prop="updated_by.first_name"
        sortable
        label="Modifié par">
        <template slot-scope="scope">
          <span v-if="scope.row.updated_by">{{scope.row.updated_by.first_name}} {{scope.row.updated_by.last_name}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updated_at"
        sortable
        label="Modifié le">
        <template slot-scope="scope">
          <span>{{_moment(scope.row.updated_at)}}</span>
        </template>
      </el-table-column>
      <el-table-column width="100">
        <template slot-scope="scope">
          <el-button
            size="mini" circle @click="editEcc(scope.row)"><i class="mdi mdi-lead-pencil" style="font-size:15px;"></i></el-button>
          <el-button
            size="mini" circle type="danger" @click="deleteEcc(scope.row.id)"><i class="mdi mdi-delete" style="font-size:15px;"></i></el-button>
        </template>
      </el-table-column>
      <div slot="empty" class="el-table__row">
        <span>Il existe aucun gabarit de courriel personnalisé!</span><br>
        <el-button size="small" @click="createEcc">Créer un nouveau gabarit</el-button>
      </div>
    </el-table>
    <EmailCustomContentDialog :visible="emailCustomContentDialogVisible" :emailContentTypeToEdit="eccToEdit" @close="closeEmailCustomContentDialog" @created="handleNewEccCreatedEvent" @updated="handleEccUpdatedEvent"></EmailCustomContentDialog>
  </div>
</template>
<script>

import eccAPI from '@/services/API/emailCustomContent'
import EmailCustomContentDialog from './components/emailCustomContentDialog'
import moment from 'moment-timezone'
export default {
  name: 'EmailCustomContentManagment',

  data() {
    return {
      emailCustomContents : [],
      selectedEcc : null,
      leftPanelSpan : 24,
      pageWidth : 0,
			pageHeight : 0,
      rightPanelSpan:0,
      showRightPanel:false,
      loading :true,
      emailCustomContentDialogVisible : false,
      eccToEdit : null,
    };
  },components: {
    EmailCustomContentDialog
  },
	methods: {
    handleEccUpdatedEvent(eccUpdated){
      this.fetchEmailCustomContent();
    },
    handleNewEccCreatedEvent(eccCreated){
      this.fetchEmailCustomContent();
    },
    showEmaiCustomContentDialog(){
      this.emailCustomContentDialogVisible=true;
    },
    closeEmailCustomContentDialog(){
      this.eccToEdit=null;
      this.emailCustomContentDialogVisible=false;
    },
    editEcc(ecc){
      this.eccToEdit=ecc;
      this.showEmaiCustomContentDialog();
    },
    _moment(datetime){
      return  moment(datetime).format('DD/MM/YYYY');
    },
    deleteEcc(id){
      this.$confirm('Ceci supprimer définitivement le gabarit. Continuer?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(()=>{
          eccAPI.delete(id)
            .then(()=>{
              this.fetchEmailCustomContent();
            })
        }).catch(err=>{})

    },
    selectEcc(ecc){
      this.selectedEcc = ecc;
    },
    createEcc(){
      this.showEmaiCustomContentDialog();
    },
    fetchEmailCustomContent(){
      this.loading = true;
      eccAPI.fetchEmailCustomContent()
        .then(emailCustomContents=>{
          this.emailCustomContents = emailCustomContents
          this.loading=false;
        })
    },
    __resizeHanlder: _.throttle(function (e) {
			this.setPageWidth();
		}, 700),
    setPageWidth() {
			this.pageWidth = document.getElementById('page-panel').offsetWidth;
			this.pageHeight = document.getElementById('page-panel').offsetHeight;
		},
	},
	computed: {
    getHeightStyle(){
      return this.pageHeight - 70;
    },

	},
  mounted(){
    this.setPageWidth()
  },
  created(){
    this.fetchEmailCustomContent();
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';

.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:50px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}
.active{
  background-color: lighten($background-color, 20%);
  border-radius: 5px;
  box-shadow:none;
  box-shadow: 0 4px 8px 0 rgba(40,40,90,.09),0 1px 3px 0 rgba(0,0,0,.065);
}

.item-list {
  //margin: 0 auto;
  width: 100%;
  // padding: 0px 30px;
  box-sizing: border-box;

  .item {
    margin: 10px 0;
    padding: 5px;
    box-sizing: border-box;
    cursor: pointer;
    transition: all .5s .25s;


    .info {
      word-break: break-word;

    }

    &:hover {
      //margin: 15px -20px;
      //padding: 10px;
      background-color: lighten($background-color, 20%);
      border-radius: 5px;
      box-shadow: 0 8px 16px 0 rgba(40,40,90,.09),0 3px 6px 0 rgba(0,0,0,.065);

    }

  }
}

@media (max-width: 1024px) {

	#page-panel{
		padding:0px;
		margin:0px;
	}

	.customer-top-nav{
		height:60px;
		padding-top:10px;
		padding-left:10px;
		padding-right:10px;
	}

}

</style>
